/**
 * Tiny class-name combinator used by every component in `@cakewalk/ui`.
 * Pulled out as a named module so we don't pull in `clsx` / `classnames`
 * (banned by approved-libraries.mdc — there is no row for them and the
 * one-liner below covers every use we need).
 */
export type ClassValue = string | false | null | undefined;

export function cx(...values: readonly ClassValue[]): string {
  return values.filter((v): v is string => typeof v === "string" && v.length > 0).join(" ");
}
